module.exports = __webpack_public_path__ + "img/logo-ct.c1337adf.png";